import { Controller } from "stimulus";
import $ from "jquery";

export default class extends Controller {
  connect() {
    const $select = $(this.element).find("select").addBack("select");
    const placeholder = this.data.get("placeholder") || "Search...";
    const width = this.data.get("width") || "100%";

    $select.select2({
      width: width,
      placeholder: placeholder,
      allowClear: true,
    });

    $select.on("select2:open", () => {
      const searchField = document.querySelector(
        ".select2-container--open .select2-search__field"
      );
      if (searchField) {
        searchField.setAttribute("placeholder", placeholder);
        searchField.focus();
      }
    });
  }

  disconnect() {
    const $select = $(this.element).find("select").addBack("select");
    if ($select.data("select2")) {
      $select.select2("destroy");
    }
  }
}
